import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as d, normalizeClass as s, createElementVNode as n } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconUserSpeak",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.354 1.087a.437.437 0 0 1 .559.267c.237.672.366 1.394.366 2.146s-.129 1.474-.366 2.146a.437.437 0 1 1-.825-.292c.205-.58.316-1.203.316-1.854 0-.65-.111-1.275-.316-1.854a.437.437 0 0 1 .267-.558ZM5 1.938a1.562 1.562 0 1 0 0 3.125 1.562 1.562 0 0 0 0-3.125ZM2.563 3.5a2.437 2.437 0 1 1 4.875 0 2.437 2.437 0 0 1-4.875 0Zm5.773-1.906a.438.438 0 0 1 .57.242c.208.514.322 1.076.322 1.664 0 .588-.114 1.15-.322 1.664a.438.438 0 0 1-.811-.328c.166-.412.258-.863.258-1.336 0-.473-.092-.924-.258-1.336a.438.438 0 0 1 .241-.57Zm-6.56 6.182A2.438 2.438 0 0 1 3.5 7.063h3A2.438 2.438 0 0 1 8.938 9.5v1a.438.438 0 0 1-.875 0v-1A1.563 1.563 0 0 0 6.5 7.937h-3A1.563 1.563 0 0 0 1.938 9.5v1a.438.438 0 0 1-.875 0v-1c0-.646.257-1.266.714-1.724Z",
  fill: "currentColor"
}, null, -1), m = [
  _
];
function u(e, p, r, f, h, a) {
  return d(), i("svg", {
    "aria-label": r.ariaLabel,
    class: s([a.iconSizeClass, "d-icon d-icon--user-speak"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "User Speak",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const g = /* @__PURE__ */ l(o, [["render", u]]);
export {
  g as default
};
//# sourceMappingURL=user-speak.js.map
